import { apiClient } from './api-client';
import { 
  ApiResponse, 
  ExamChapter, 
  ListExamChaptersResponse, 
  BulkCreateExamChaptersRequest,
  BulkCreateExamChaptersResponse 
} from '../types';

export class ExamChapterService {
  
  static async getExamChaptersByExamSubjectId(examSubjectId: number): Promise<ListExamChaptersResponse> {
    try {
      const response = await apiClient.get<ApiResponse<ListExamChaptersResponse>>(`/exam-chapters/exam-subject/${examSubjectId}`);
      return response.data.data;
    } catch (error) {
      console.error('Error fetching exam chapters:', error);
      throw error;
    }
  }

  static async getExamChapterById(id: number): Promise<ExamChapter> {
    try {
      const response = await apiClient.get<ApiResponse<ExamChapter>>(`/exam-chapters/${id}`);
      return response.data.data;
    } catch (error) {
      console.error('Error fetching exam chapter:', error);
      throw error;
    }
  }

  static async createExamChapter(chapterData: {
    exam_subject_id: number;
    chapter_id: number;
    name: string;
    display_order?: number;
  }): Promise<ExamChapter> {
    try {
      const response = await apiClient.post<ApiResponse<ExamChapter>>('/exam-chapters', chapterData);
      return response.data.data;
    } catch (error) {
      console.error('Error creating exam chapter:', error);
      throw error;
    }
  }

  static async updateExamChapter(id: number, chapterData: {
    name?: string;
    display_order?: number;
  }): Promise<ExamChapter> {
    try {
      const response = await apiClient.put<ApiResponse<ExamChapter>>(`/exam-chapters/${id}`, chapterData);
      return response.data.data;
    } catch (error) {
      console.error('Error updating exam chapter:', error);
      throw error;
    }
  }

  static async deleteExamChapter(id: number): Promise<void> {
    try {
      await apiClient.delete(`/exam-chapters/${id}`);
    } catch (error) {
      console.error('Error deleting exam chapter:', error);
      throw error;
    }
  }

  static async reorderExamChapters(examSubjectId: number, chapterOrders: {
    id: number;
    display_order: number;
  }[]): Promise<void> {
    try {
      await apiClient.put('/exam-chapters/reorder', {
        exam_subject_id: examSubjectId,
        chapter_orders: chapterOrders
      });
    } catch (error) {
      console.error('Error reordering exam chapters:', error);
      throw error;
    }
  }

  static async bulkCreateExamChapters(data: BulkCreateExamChaptersRequest): Promise<BulkCreateExamChaptersResponse> {
    try {
      const response = await apiClient.post<ApiResponse<BulkCreateExamChaptersResponse>>('/exam-chapters/bulk', data);
      return response.data.data;
    } catch (error) {
      console.error('Error bulk creating exam chapters:', error);
      throw error;
    }
  }

  static async bulkDeleteExamChapters(ids: number[]): Promise<void> {
    try {
      await apiClient.delete('/exam-chapters/bulk', {
        data: { ids }
      });
    } catch (error) {
      console.error('Error bulk deleting exam chapters:', error);
      throw error;
    }
  }
}